var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"extra-large":"","title":"Inconsistências"},scopedSlots:_vm._u([{key:"footer",fn:function({ cancel }){return [_c('rkm-button',{on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.inconsistencias,"hide-filters":"","hide-pagination":"","sort-by":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }